export default {
  setProfile({ profile, token, distinctId }) {
    this.profile = profile;
    this.promotionParticipation = {
      ...profile.promotionParticipation,
      active:
        profile.promotionParticipation?.promotion.status === 'active' || false,
    };
    this.token = token || this.token;
    this.distinctId = distinctId || this.distinctId;
    this.paymentSettings = profile.paymentSettings;
    this.isAuth = !!profile;

    this.setUserDataToFbq();
  },

  setToken(token) {
    this.token = token;
  },

  setDistinctId(distinctId) {
    this.distinctId = distinctId;
  },

  setNewCardForSelectedCard() {
    this.selectedCardId = 'stripe';
  },

  setPaymentMethods(paymentMethods) {
    this.paymentMethods = paymentMethods;
  },

  setSelectedCardId(selectedCardId) {
    this.selectedCardId = selectedCardId || 'stripe';
  },

  removePromotion() {
    this.promotionParticipation.active = false;
  },

  resetProfile() {
    this.profile = null;
    this.isAuth = false;
    this.token = null;
    this.distinctId = null;
    this.promotionParticipation = null;
    this.selectedCardId = 'stripe';
    this.paymentMethods = [];
    this.paymentSettings = null;

    this.setUserDataToFbq();
  },

  async setUserDataToFbq() {
    if (!window?.fbq) return;

    const url = useRequestURL();
    const hostname = url.hostname;
    const tld = hostname.split('.').pop();

    const pixelMap = {
      am: '2170654943286875',
      app: '9340488419403038',
    };

    const pixelId = pixelMap[tld];

    setTimeout(() => {
      if (!window.fbq?.instance?.pixelsByID[pixelId].userData) return;

      window.fbq.instance.pixelsByID[pixelId].userData.em = this.isAuth
        ? this.profile.email
        : null;

      window.fbq.instance.pixelsByID[pixelId].userData.fn = this.isAuth
        ? this.profile.firstName
        : null;

      window.fbq.instance.pixelsByID[pixelId].userData.ln = this.isAuth
        ? this.profile.lastName
        : null;
    });
  },

  async setDefaultPaymentMethod(bankCardId) {
    this.selectedCardId = bankCardId;
  },
};
